var moduleMap = {
	"./app": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_cisco-sbg_cspe-mfe-shared-library_dist_esm_index_js-node_modules_ciscode-3bd635"), __webpack_require__.e("src_App_tsx-src_api_config_apiRegion_ts-webpack_sharing_consume_default_react_react"), __webpack_require__.e("src_modulefederation_SecureClientApp_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/modulefederation/SecureClientApp.tsx */ "./src/modulefederation/SecureClientApp.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});